import { render, staticRenderFns } from "./atcd-historique-adulte-familiaux.html?vue&type=template&id=479bf3d6&scoped=true&external"
import script from "./atcd-historique-adulte-familiaux.js?vue&type=script&lang=js&external"
export * from "./atcd-historique-adulte-familiaux.js?vue&type=script&lang=js&external"
import style0 from "./atcd-historique-adulte-familiaux.scss?vue&type=style&index=0&id=479bf3d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479bf3d6",
  null
  
)

export default component.exports